export * from './formatRoutesToArr';
export { default as getLazyRoutes } from './getLazyRoutes';
